var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "66", height: "77", viewBox: "0 0 66 77" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#A0CFF9", d: "M0 8.98h56.94V77H0z" }),
      React.createElement("path", { fill: "#9E9BD6", d: "M62.12 48.77L51.77 61.6l-3.89-3.85L44 61.6l7.76 7.7L66 52.62z" }),
      React.createElement("path", { fill: "#F9A18A", d: "M19.41 0l2.79 16.68h12.54L37.53 0z" }),
      React.createElement("ellipse", { cx: "28.47", cy: "7.7", fill: "#F7E88B", rx: "2.59", ry: "2.57" }),
      React.createElement("path", { fill: "#F5EAA2", d: "M7.76 21.82h41.42v28.23H7.76z" }),
      React.createElement("path", { fill: "#60B2FD", d: "M6.47 53.9h19.41v2.57H6.47zm22 0h7.76v2.57h-7.76zm-22 7.7h31.06v2.57H6.47zm32.35-7.7H44v2.57h-5.18zM6.47 69.3h11.65v2.57H6.47zm14.24 0h20.7v2.57h-20.7z" }),
      React.createElement("path", { fill: "#F9A18A", d: "M31.79 37.28a5.1 5.1 0 0 0 1.55-5.7 5.17 5.17 0 0 0-4.87-3.38 5.17 5.17 0 0 0-4.87 3.39 5.1 5.1 0 0 0 1.55 5.69 5 5 0 0 0-4.44 4.95v7.82h15.53v-7.82a5 5 0 0 0-4.45-4.95z" })
    )
  );
});